export default {
  tab: 'Comentarios',
  toolbar: {
    markup: 'Anotar',
    record: 'Grabar',
    hint: 'Clic para comentar, arrastrar para dibujar',
    hintTouch: 'Arrastra para marcar el problema',
    hintRecord: 'Grabando pantalla',
    exit: 'Salir',
  },
  popup: {
    about: 'Acerca de',
    placeholder: 'Describe el problema o sugerencia...',
    submit: 'Enviar',
    sending: 'Enviando...',
    cancel: 'Cancelar',
    close: 'Cerrar',
    my_feedback: 'Mis comentarios',
    screenshot_label: 'Adjuntar captura de pantalla',
    screenshot_hint: 'Las contraseñas y otros campos sensibles se ocultan automáticamente.',
    screenshot_short: 'Captura',
    screenshot_locked_hint: 'Tu dibujo se integra en la captura, por eso siempre se adjunta. Los campos sensibles se ocultan automáticamente.',
    recording_label: 'Grabación',
    recording_locked_hint: 'Una reproducción de lo que mostraba la página y cómo se usó; siempre se adjunta. Sin cámara ni micrófono. Los campos sensibles se ocultan automáticamente.',
    quickOptions: [
      { emoji: '🐛', label: 'Error', value: 'Algo no funciona' },
      { emoji: '💡', label: 'Sugerencia', value: 'Tengo una sugerencia' },
      { emoji: '🤔', label: 'Confuso', value: 'Estoy confundido' },
    ],
  },
  success: {
    title: 'Gracias, hemos recibido tu comentario.',
    title_no_ai: '¡Gracias! Hemos recibido tu comentario.',
    close: 'Cerrar',
    email_saved: 'Recibirás un correo cuando se resuelva.',
    email_error: 'No se pudo guardar tu correo. Inténtalo de nuevo.',
    track_feedback: 'Seguir mi comentario',
    email_cta: 'Avísame por correo cuando se arregle',
    notify: 'Avisarme',
  },
  error: {
    submit: 'Error al enviar. Por favor, inténtalo de nuevo.',
    finalize_title: 'Aún no pudimos enviarlo.',
    finalize_message: 'Tu comentario sigue guardado. Inténtalo de nuevo.',
  },
  pet: {
    bubble: '¿Necesitas ayuda?',
  },
  frustration: {
    prompt: '¿Algo no funciona? Cuéntanos.',
    action: 'Anotar',
    dismiss: 'Cerrar',
  },
  annotation: {
    drawing: 'Dibujo',
    element: 'elemento',
  },
  draw: {
    note_placeholder: 'Añade una nota a tu dibujo',
    undo: 'Deshacer',
    redo: 'Rehacer',
    cancel: 'Cancelar',
    submit: 'Enviar',
  },
  record: {
    stop: 'Detener',
    timer_label: 'Grabando',
    max_reached: 'Tiempo máximo de grabación alcanzado',
    replay_label: 'screen-recording.json',
    play: 'Reproducir grabación',
    close: 'Cerrar',
    preview_unavailable: 'Vista previa no disponible',
  },
  clarify: {
    title: 'Make This Better AI',
    subtitle: 'Afinando tus comentarios',
    thinking: 'Pensando...',
    placeholder: 'Añade detalles y envía',
    send: 'Enviar',
    submit: 'Enviar',
    send_feedback: 'Enviar comentario',
    skip: 'Omitir y enviar',
    skip_short: 'Omitir',
    cancel: 'Cancelar — no enviar',
    retry: 'Reintentar',
    error: 'No se pudo cargar la pregunta. Envía tus comentarios tal cual.',
    expired: 'Esta sesión de comentarios caducó antes de poder enviarse. Cierra el widget y envíalo de nuevo.',
  },
}
